import { Injectable } from '@angular/core';
import { DetailService } from '../shared/detail/detail.service';
import { DialogService } from '../shared/dialog/dialog.service';
import { ButtonInvoke } from '../shared/panel-buttons/panel-buttons.component';
import { UserDataService } from '../user-data/user-data.service';
import { IdentityUserUpdateRolesDto } from '../user-role-data/models/UserRoleDtos';
import { UserRoleAssignableService } from '../user-role-data/user-role-assignable.service';
import { UserRoleDataService } from '../user-role-data/user-role-data.service';
import { UserRoleComponent } from './user-role.component';

@Injectable()
export class UserRoleService{

  component: UserRoleComponent | any;

  constructor(private userRoleDataService: UserRoleDataService, private userRoleAssignable: UserRoleAssignableService, private userDataService: UserDataService) {
  }

  public createToolbarButtons() : ButtonInvoke[]{
    let buttons: ButtonInvoke[] = [];
    buttons.push(new ButtonInvoke(this, 'Uložit', 'save', '<i class="cml-fw cml-lg cml-floppy-o"></i>', 'cml-active-green'));
    buttons.push(new ButtonInvoke(this, 'Detail', 'navigateToDetail', '<i class="cml-fw cml-lg cml-arrow-left"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, 'Zavřít', 'close', '<i class="cml-fw cml-lg cml-close"></i>', 'cml-active-black'));
    return buttons
  }

  public async get(entityId: string) {
    let result = await this.userRoleDataService.get(entityId);
    if (result && result.items) {
      return result.items;
    }
    return null;
  }

  async invoke(method: Exclude<keyof UserRoleService, "createToolbarButtons" | "get" | "getUser" | "edit" | "getRoles" | "invoke">) {
    await this.component.invoke(method);
  }

  public async getUser(entityId: string) {
    return await this.userDataService.get(entityId);
  }

  public async edit(entityId: string, entity: IdentityUserUpdateRolesDto) {
    return await this.userRoleDataService.edit(entityId, entity);
  }

  public getRoles() {
    return this.userRoleAssignable.assignableRoles$;
  }
}
